import React from 'react';
import { Slide } from '../../components/deck/Slide';
import { Eyebrow, INK, Label, Reveal, Title } from '../../components/deck/Type';
const SERIF = {
  fontFamily: 'var(--font-serif)'
} as const;
const reasons = ['High-value decisions', 'Large volumes of unstructured information', 'Repeatable diligence workflows', 'Expensive analyst time', 'Strong proprietary data value', 'Fragmented technology stack'];
const proof = [{
  value: '$100K',
  label: 'Sony Innovation Fund paid engagement'
}, {
  value: '5',
  label: 'Venture funds signed'
}, {
  value: '20,000+',
  label: 'Startups assessed'
}];
export function VcWedgeSlide() {
  return <Slide data-id="element-427" data-mp="163nftkq3ehru">
      <Eyebrow data-id="element-428" data-mp="163dp1ux846l3">Initial market</Eyebrow>
      <Title className="mt-[2.2cqh]" data-id="element-429" data-mp="113949spa8pp2">Venture capital is the wedge.</Title>

      <div className="mt-auto grid grid-cols-[1fr_32%] gap-[4cqw]" data-id="element-430" data-mp="3qrjlobspn79d">
        <div data-id="element-431" data-mp="3qpowumebiv00">
          <Label tone={INK.blue} data-id="element-432" data-mp="3qpf9z7okl3yj">Why venture capital first</Label>
          <div className="mt-[2.4cqh] grid grid-cols-2 gap-x-[2.4cqw]" data-id="element-433" data-mp="3lr5curjabtaa">
            {reasons.map((r, i) => <Reveal key={r} delay={0.05 * i} className="flex items-baseline gap-[1cqw] border-b border-white/10 py-[2.2cqh]" data-id="element-434" data-mp="28xu1r3ndasp6" data-mpi={i}>
                <span className="text-[0.8cqw] tracking-[0.22em] text-white/35" data-id="element-435" data-mp="1yywb9v6dsp3j">{String(i + 1).padStart(2, '0')}</span>
                <span className="text-[1.5cqw] leading-tight text-[#F4F7FC]" style={SERIF} data-id="element-436" data-mp="23xfxzxssu4wy">
                  {r}
                </span>
              </Reveal>)}
          </div>
        </div>

        <Reveal delay={0.3} className="flex flex-col border border-[#2FBE8F]/35 bg-[#2FBE8F]/[0.05] p-[1.8cqw]" data-id="element-437" data-mp="1uxj67nb44pxo">
          <Label tone={INK.emerald} data-id="element-438" data-mp="1g9fzgbp8xa7t">Already validated here</Label>
          <div className="mt-[2.4cqh] space-y-[2.6cqh]" data-id="element-439" data-mp="1l781hyjlucpq">
            {proof.map(p => <div key={p.label} data-id="element-440" data-mp="177otd5qsn1df">
                <p className="text-[2.6cqw] leading-none text-[#F4F7FC]" style={SERIF} data-id="element-441" data-mp="178rknes135tv">
                  {p.value}
                </p>
                <div className="mt-[0.8cqh]" data-id="element-442" data-mp="1bbehju3k3gxx">
                  <Label data-id="element-443" data-mp="3dwh103h85flf">{p.label}</Label>
                </div>
              </div>)}
          </div>
          <p className="mt-auto pt-[2.4cqh] text-[0.95cqw] text-[#AEB7C7]" data-id="element-444" data-mp="3947ih8ifvht6">
            Next: the same architecture, applied to adjacent technology decisions →
          </p>
        </Reveal>
      </div>
    </Slide>;
}